<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle" v-if="getUser != null && getUser.roleName == $role.ADMIN">공지사항 관리</h1>
                <h1 class="boardTitle" v-else>공지사항</h1>
                <div>
                    <div class="row4">
                        <div class="mobileReversePosition">
                            <div class="topContent flex">
                                <div class="left flex mobileReset">
                                    <p>총 <span>{{ totalCnt }}</span>건</p>
                                    <p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
                                </div>
                                <div class="flex mWd100">
                                    <Search />
                                    <div class="btnBox blankLeft inlineB"
                                        v-if="getUser != null && getUser.roleName == $role.ADMIN">
                                        <button class="greenBtn smBtn" type="button" @click="writeBtn()">등록</button>
                                        <button class="orangeBtn smBtn" type="button" @click="deleteBtn()">삭제</button>
                                    </div>
                                </div>
                            </div>
                            <div class="noticeBox" v-if="getUser == null || getUser.roleName != $role.ADMIN">
                                <div class="borderBox">
                                    <p>
                                        공지, 뉴스, 이벤트 등 여러가지 소식을 알려드립니다.<br class="mobileNotBr">
                                        궁금증이 해결되지 않으면 로그인 후 1:1 문의를 이용해 주세요.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mobileBlock totalCount">
                            <p>총 <span class="colorRed">{{ totalCnt }}</span>건</p>
                        </div>
                        <div class="noticeBoard">
                            <Board ref="board" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import Board from '@/components/layout/board/Board'
import axios from '@/axios/axios'
import Search from '@/components/layout/board/Search'
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'Notice',
    components: {
        Board,
        Search
    },
    computed: {
        ...mapGetters('auth', [
            'getUser'
        ]),
        ...mapState("board", ["perPage", "currentPage", "totalCnt"]),
        totalPage() {
            let totalCnt = this.$store.state.board.totalCnt;
            let perPage = this.$store.state.board.perPage;

            if (totalCnt == 0) return 1;
            else if (totalCnt % perPage == 0) return totalCnt / perPage;
            else return Math.floor(totalCnt / perPage) + 1;
        }
    },
    data() {
        return {
            fields: [
                {
                    key: 'ROWNUM',
                    label: 'NO.',
                    sortable: false
                },
                {
                    key: 'TITLE',
                    label: '제목',
                    sortable: false
                },
                {
                    key: 'NAME',
                    label: '작성자',
                    sortable: false
                },
                {
                    key: 'REGDATE',
                    label: '등록일',
                    sortable: false
                },
                {
                    key: 'VIEW_CNT',
                    label: '조회수',
                    sortable: false
                },
                {
                    key: 'FILE_NAME',
                    label: '첨부파일',
                    sortable: false,
                    formatter: "isFileUpload",
                    class: 'text-center'
                }
            ]
        }
    },
    methods: {
        setNotice() {
            if (this.$store.state.auth.user != null && this.$store.state.auth.user.roleName == this.$role.ADMIN) {
                this.fields = [
                    {
                        key: 'selected',
                        label: '선택',
                        class: 'text-center',
                        sortable: false
                    },
                    {
                        key: 'ROWNUM',
                        label: 'NO.',
                        sortable: false
                    },
                    {
                        key: 'TITLE',
                        label: '제목',
                        sortable: false
                    },
                    {
                        key: 'NAME',
                        label: '작성자',
                        sortable: false
                    },
                    {
                        key: 'REGDATE',
                        label: '등록일',
                        sortable: false
                    },
                    {
                        key: 'VIEW_CNT',
                        label: '조회수',
                        sortable: false
                    },
                    {
                        key: 'FILE_NAME',
                        label: '첨부파일',
                        sortable: false,
                        formatter: "isFileUpload",
                        class: 'text-center'
                    }
                ]
            }

            let boarObj = {
                getListURL: "/api/notice/getNoticeList",
                currentPage: 1,
                perPage: 10,
                sortBy: 'IDX',
                sortDesc: false,
                searchText: "",
                routerName: "noticeDetail",
                url: "/notice",
                fields: this.fields
            };

            this.$store.dispatch('board/setBoardSetting', boarObj);

        },
        writeBtn() {
            this.$router.push({ name: 'noticeManagementWrite' });
        },
        deleteBtn() {
            let selected = this.$refs.board.selected;
            if (selected.length == 0) {
                this.$alert("알림", "삭제할 글을 선택해주세요.");
                return false;
            }

            var response = this.$createConfirmResponse()
            this.$confirm("알림", `${selected.length}개 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
                'closed': () => {
                    if (response.result) {
                        let paramDatas = { list: selected };
                        axios.post('/api/admin/notice/delete', paramDatas)
                            .then(result => {
                                if (result.status == 200) {
                                    this.$alert("알림", `공지사항이 삭제되었습니다.`, "", {
                                        'closed': () => {
                                            this.$refs.board.$refs.table1.refresh();
                                            this.$refs.board.$refs.table2.refresh();
                                        }
                                    });
                                }
                                else {
                                    this.$alert("알림", `공지사항 삭제에 실패하였습니다.`);
                                }
                            })
                            .catch((error) => {
                                this.$alert("알림", `공지사항 삭제실패하였습니다. <br>` + error);
                            });
                    }
                }
            });
        }
    },
    created() {
        this.setNotice();
    },

}

</script>

<style scoped>
a {
    color: #272727;
}

h3 {
    margin: 0 0 16px 0;
}
</style>

<style></style>

